import { createStore } from 'vuex';

import auth from './auth';
import users from './users';
import orders from './orders';


export default createStore({
  modules: {
    auth,
    users,
    orders,
  }
});